import React, { Component, useEffect, useState, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import ReactSelect from "components/ReactSelect"
import fieldStatus from "helpers/fieldStatus"
import { toast } from "react-toastify"
import submitData from "helpers/submitData"
import { Formik, Field, Form, useFormikContext } from "formik"
import fields from "models/lotSalesStatus"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import NumberField from "components/NumberField"
import DateField from "components/DateField"

function ManageLotSalesStatus(props) {
	const [ready, setReady] = useState(false)

	const InternalForm = () => {
		const f = useFormikContext()
		const [rows, setRows] = useState([])

		useEffect(() => {
			lookupData(f)
		}, [f.values.builder, f.values.lot_type, f.values.section_id])

		useEffect(() => {
			buildRows()
		}, [f.values.start, f.values.end])

		const submitClasses = (f) => {
			var classNames = require("classnames")
			var submitClasses = classNames("form__submit", {
				"form__submit--ready": f,
			})

			return submitClasses
		}

		const options = (f, name) => {
			let ret = []
			props.payload.public[name].forEach((v) => {
				if (props.activeProperties[0] == v.property) {
					ret.push({ label: v.name, value: v.id })
				}
			})

			ret = _.sortBy(ret, "label")
			return ret
		}

		const optionsAlpha = (name) => {
			let opts = _.map(props.payload.public[name], (v) => {
				return { label: v.name, value: v.id }
			})
			opts = _.sortBy(opts, "label")
			return opts
		}

		const buildRows = () => {
			let tmp = []
			if (f.values.start && f.values.end) {
				let months = helpers.monthsBetween(f.values.start, f.values.end)
				_.forEach(months, (v, k) => {
					let path = `${v.month}-${v.yearShort}`
					tmp.push({
						year: v.yearShort,
						month: v.fullMonth,
						contracted: (
							<>
								<NumberField
									name={`data.${path}`}
									type="text"
									numeric={true}
									className="form__input"
									onChange={f.setFieldValue}
									onBlur={f.setFieldTouched}
									key={_.random(0, 500000)}
									value={f.values.data[path]}
								/>
							</>
						),
					})
				})
			}
			setRows(tmp)
		}

		const lookupData = async (f) => {
			if (!f || !f.values) return
			if (f.values.builder && f.values.lot_type && f.values.section_id) {
				f.values.property = props.activeProperties[0]
				let lookup = {
					builder: f.values.builder,
					property: props.activeProperties[0],
					lot_type: f.values.lot_type,
					section_id: f.values.section_id,
				}
				props.loadingStatus(true)
				setReady(true)
				submitData("lotSalesStatusLookup", lookup)
					.then((resp) => {
						f.setFieldValue("data", resp.data.data)
						f.setFieldValue("base_price", resp.data.base_price)
						f.setFieldValue("notes", resp.data.notes)
						f.setFieldValue("start", resp.data.start)
						f.setFieldValue("end", resp.data.end)
						f.setFieldValue("id", resp.data.id)
						props.loadingStatus(false)
					})
					.catch((e) => {
						// This combo doesn't exist yet, have to create it and wipe out existing data in f.values.
						f.setFieldValue("base_price", "")
						f.setFieldValue("start", false)
						f.setFieldValue("end", false)
						f.setFieldValue("notes", "")
						f.setFieldValue("data", {})
						f.setFieldValue("id", false)
						props.loadingStatus(false)
						console.log("Combo doesnt exist.  Create new set.")
					})
			}
		}

		let columns = [
			{
				Header: "Month",
				accessor: "month",
				filterMethod: (f, r) => helpers.tableText(f, r, "month"),
			},
			{
				Header: "Year",
				accessor: "year",
				filterMethod: (f, r) => helpers.tableText(f, r, "year"),
			},
			{
				Header: "Contracted",
				accessor: "contracted",
				filterMethod: (f, r) => helpers.tableText(f, r, "contracted"),
			},
		]
		return (
			<div>
				<Form>
					<div className="reportGroup">
						<h3>Data Set</h3>
						<ul className="form__list">
							<li className={fieldStatus("builder", f, false, false, false)}>
								<label htmlFor="builder">
									Builder <sup>*</sup>
								</label>
								{f.errors.builder && f.touched.builder && (
									<div className="form__message">{f.errors.builder}</div>
								)}
								<ReactSelect
									name={`builder`}
									options={optionsAlpha("builders")}
									value={f.values.builder}
									onBlur={f.setFieldTouched}
									onChange={(field, v) => {
										f.setFieldValue("builder", v)
									}}
								/>
							</li>
							<li className={fieldStatus("section_id", f, false, false, false)}>
								<label htmlFor="section_id">
									Section <sup>*</sup>
								</label>
								{f.errors.section_id && f.touched.section_id && (
									<div className="form__message">{f.errors.section_id}</div>
								)}
								<ReactSelect
									name={`section_id`}
									options={options(f, "sections")}
									value={f.values.section_id}
									onBlur={f.setFieldTouched}
									onChange={(field, v) => {
										f.setFieldValue("section_id", v)
									}}
								/>
							</li>
							<li className={fieldStatus("lot_type", f, false, false, false)}>
								<label htmlFor="lot_type">
									Lot Type <sup>*</sup>
								</label>
								{f.errors.lot_type && f.touched.lot_type && (
									<div className="form__message">{f.errors.lot_type}</div>
								)}
								<ReactSelect
									name={`lot_type`}
									options={options(f, "lot_types")}
									value={f.values.lot_type}
									onBlur={f.setFieldTouched}
									onChange={(field, v) => {
										f.setFieldValue("lot_type", v)
									}}
								/>
							</li>
						</ul>
					</div>
					{ready && (
						<div className="reportGroup">
							<h3>Data</h3>
							<ul className="form__list">
								<li className={fieldStatus("start", f, false, false, false)}>
									<label htmlFor="start">
										Start of Contract <sup>*</sup>
									</label>
									{f.errors.start && f.touched.start && (
										<div className="form__message">{f.errors.start}</div>
									)}
									<DateField
										name="start"
										className="form__textarea"
										value={f.values.start}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.start}
										error={f.errors.start}
									/>
								</li>
								<li className={fieldStatus("end", f, false, false, false)}>
									<label htmlFor="end">
										End of Contract <sup>*</sup>
									</label>
									{f.errors.end && f.touched.end && (
										<div className="form__message">{f.errors.end}</div>
									)}
									<DateField
										name="end"
										className="form__textarea"
										value={f.values.end}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.end}
										error={f.errors.end}
									/>
								</li>
								<li className={fieldStatus("base_price", f, false, false, false)}>
									<label htmlFor="base_price">
										Base Price <sup>*</sup>
									</label>
									{f.errors.end && f.touched.end && (
										<div className="form__message">{f.errors.end}</div>
									)}
									<NumberField
										name="base_price"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.base_price}
										error={f.errors.base_price}
										value={f.values.base_price}
										thousandSeparator={true}
									/>
								</li>
								<li className={fieldStatus("notes", f, false, false, false)}>
									<label htmlFor="notes">Notes</label>
									{f.errors.end && f.touched.end && (
										<div className="form__message">{f.errors.end}</div>
									)}
									<TextArea
										name="notes"
										className="form__textarea"
										value={f.values.notes}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.notes}
										error={f.errors.notes}
									/>
								</li>
							</ul>
						</div>
					)}
					{ready && (
						<>
							<FullTable
								data={rows}
								columns={columns}
								name="lotSalesStatus"
								title="Lot Sales Status"
								classNames="small"
								sortable={false}
								pageSize={30}
							/>
							<input type="submit" value="Submit" className={submitClasses(f.isValid)} />
						</>
					)}
				</Form>
			</div>
		)
	}

	const validation = () => {
		return Yup.object().shape({
			builder: Yup.number().required("Required"),
			lot_type: Yup.number().required("Required"),
			section_id: Yup.number().required("Required"),
		})
	}

	if (props.activeProperties.length !== 1) {
		return (
			<div className="pleaseChoose">
				<h1>Please choose one community to manage.</h1>
			</div>
		)
	} else if (props.payloadStatus) {
		return (
			<div>
				<div className="imageGroup">
					<Title title="Lot Sales Status Entry" showDate={false} />
					<div className="content">
						<Formik
							enableReinitialize
							initialValues={fields}
							validationSchema={validation}
							validateOnMount={true}
							onSubmit={(values) => {
								props.loadingStatus(true)
								//return
								submitData("updateLotSalesStatus", values).then((data) => {
									props.loadingStatus(false)
									toast.success(data.message)
									
								})
							}}>
							<InternalForm />
						</Formik>
					</div>
				</div>
			</div>
		)
	} else {
		return ""
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ManageLotSalesStatus)
